import { useEffect, useState } from 'react';
import { useInterval } from 'react-use';

export default function usePrivyEmailOtpResendTimeout() {
	const [isOtpSent, setIsOtpSent] = useState(false);
	const [secondsRemaining, setSecondsRemaining] = useState(0);

	// Kick off the interval every time the code is sent. Note, we continue
	// from where we left off if there's already a value in local storage.
	useEffect(() => {
		if (isOtpSent) {
			setSecondsRemaining((prev) => (prev ? prev : 60));
		}
	}, [isOtpSent]);

	useInterval(
		() => {
			setSecondsRemaining((prev) => {
				return prev > 0 ? prev - 1 : 0;
			});
		},
		isOtpSent && secondsRemaining > 0 ? 1000 : null
	);

	// Reset the code sent state when countdown finishes.
	useEffect(() => {
		if (!secondsRemaining) {
			setIsOtpSent(false);
		}
	}, [secondsRemaining]);

	return { otpResendSecondsRemaining: secondsRemaining, setIsOtpSent };
}
